import { useState } from 'react';
import { Monitor, Smartphone, Columns2 } from 'lucide-react';

const MODES = [
  { id: 'desktop', icon: Monitor, label: 'Desktop' },
  { id: 'mobile', icon: Smartphone, label: 'Mobile' },
  { id: 'both', icon: Columns2, label: 'Ambos' },
];

const MobileFrame = ({ html }) => (
  <div className="mx-auto" style={{ width: 375 }}>
    <div className="rounded-[24px] border-4 border-zinc-700 overflow-hidden bg-white shadow-xl">
      <div className="bg-zinc-800 h-5 flex items-center justify-center">
        <div className="w-16 h-1.5 bg-zinc-600 rounded-full" />
      </div>
      <div className="max-h-[70vh] overflow-y-auto" style={{ width: 367 }}>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </div>
  </div>
);

export const EmailPreviewFrame = ({ html, subject, previewText, fromLabel }) => {
  const [mode, setMode] = useState('desktop');

  return (
    <div className="bg-zinc-950 border border-zinc-800 rounded-xl overflow-hidden" data-testid="email-preview-frame">
      <div className="border-b border-zinc-800 p-3 bg-zinc-900/50 flex items-center justify-between gap-2">
        <div className="min-w-0">
          <p className="text-[10px] uppercase tracking-wider text-zinc-500">Vista previa</p>
          <p className="text-xs text-white font-medium truncate">{subject || 'Sin asunto'}</p>
          {previewText && <p className="text-[10px] text-zinc-400 truncate">{previewText}</p>}
          {fromLabel && <p className="text-[10px] text-zinc-500 truncate">De: {fromLabel}</p>}
        </div>
        <div className="flex items-center gap-1 bg-zinc-800 rounded-lg p-0.5 flex-shrink-0">
          {MODES.map(m => {
            const Icon = m.icon;
            return (
              <button
                key={m.id}
                type="button"
                onClick={() => setMode(m.id)}
                className={`px-2 py-1.5 rounded-md flex items-center gap-1 text-[10px] font-semibold transition-colors ${mode === m.id ? 'bg-violet-600 text-white' : 'text-zinc-400 hover:text-white'}`}
                title={m.label}
                data-testid={`preview-mode-${m.id}`}
              >
                <Icon size={12} />
                <span className="hidden xl:inline">{m.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      {mode === 'desktop' && (
        <div className="max-h-[75vh] overflow-y-auto bg-white" data-testid="preview-desktop">
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      )}

      {mode === 'mobile' && (
        <div className="py-6 bg-zinc-900 overflow-x-auto" data-testid="preview-mobile">
          <MobileFrame html={html} />
        </div>
      )}

      {mode === 'both' && (
        <div className="grid grid-cols-2 gap-3 p-3 bg-zinc-900 items-start" data-testid="preview-both">
          <div className="rounded-lg overflow-hidden border border-zinc-700 bg-white max-h-[70vh] overflow-y-auto">
            <div style={{ zoom: 0.55 }} dangerouslySetInnerHTML={{ __html: html }} />
          </div>
          <div className="max-h-[70vh] overflow-y-auto">
            <div style={{ zoom: 0.72 }}>
              <MobileFrame html={html} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
